import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { ListingQualityStatusService } from '../listing-quality-status.service';
import { ListingQualityStatus } from '../listing-quality-status';
import { PropertyService } from '@app/_components/property/property.service';
import { DevelopmentService } from '@app/_components/development';

@Component({
    selector: 'app-listing-quality-status',
    templateUrl: './listing-quality-status.component.html',
    styleUrls: ['./listing-quality-status.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class ListingQualityStatusComponent implements OnInit {
    properties: any;
    developments: any;
    property: any;

	constructor(
		private propertyService: PropertyService,
		private developmentService: DevelopmentService,
		private primengConfig: PrimeNGConfig,
		private listingQualityStatusService: ListingQualityStatusService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.listingQualityStatus = data.listingQualityStatus,
			this.statuses = listingQualityStatusService.statuses;
	}

	@Input() listingQualityStatus: ListingQualityStatus;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	qualityTestId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'qualityTestId': [],
		'shortTermRentalId': [],
		'testSubjectName': [],
		'developmentId': [],
		'adrDevelopmentName': [],
		'activityId': [],
		'featureId': [],
		'guestBookId': [],
		'createdByUserId': [],
		'createDate': [],
		'testName': [],
		'testExpectationDesc': [],
		'testResultValue': [],
		'testResultStatus': [],
		'testResultDesc': [],
		'testCategory': [],
		'testResultUrl': [],
	};
	
	ngOnInit() {
		this.fetchProperties();
		this.fetchDevelopments();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole listingQualityStatus object
		if (this.listingQualityStatus) {
			this.qualityTestId = this.listingQualityStatus.qualityTestId;
			this.fixDates();
			this.form1.patchValue(this.listingQualityStatus);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.qualityTestId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.listingQualityStatusService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.listingQualityStatus = res.data.listingQualityStatus;
						this.doAdd.emit(this.listingQualityStatus);
					},
					(err: any) => {
						console.log('listingQualityStatus-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('listingQualityStatus: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.listingQualityStatusService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.listingQualityStatus = res.data.listingQualityStatus;
						this.doUpdate.emit(this.listingQualityStatus);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.listingQualityStatusService.delete(this.listingQualityStatus.qualityTestId)
				.subscribe(
					(res: any) => {
						console.log('listingQualityStatus-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.listingQualityStatus);
					},
					(err: any) => {
						console.log('listingQualityStatus-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			qualityTestId: [this.qualityTestId],
			shortTermRentalId: [],
			testSubjectName: [],
			developmentId: [],
			adrDevelopmentName: [],
			activityId: [],
			featureId: [],
			guestBookId: [],
			createdByUserId: [],
			createDate: [],
			testName: [],
			testExpectationDesc: [],
			testResultValue: [],
			testResultStatus: [],
			testResultDesc: [],
			testCategory: [],
			testResultUrl: [],
			});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.listingQualityStatus.listingQualityStatusDate = moment(this.listingQualityStatus.listingQualityStatusDate).toDate();
	}
	
	fetchProperties() {
			try {
				this.propertyService.findById(this.listingQualityStatus.shortTermRentalId)
					.subscribe(
						res => {
							console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.property = res.data.property.propertyCode;
							this.form1.patchValue({
								propertyCode: this.property,
							});
							return this.property;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
	}
	
	fetchDevelopments() {
		if (!this.developments || this.developments === undefined || this.developments.length < 1) {
			try {
				this.developmentService.findAll()
					.subscribe(
						res => {
							// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
							this.developments = res.data.developments;
							return this.developments;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.developments);
		}
	}
}
